module.exports = __webpack_public_path__ + "static/media/lp-6.8fddd126.png";